jQuery(document).ready(function ($) {
    let $form = $('#erm_reservation_form');
    let $submit = $('#erm_reservation_btn');
    let $dateInput = $('#erm_reservation_date');
    let $timeInput = $('#erm_reservation_time');
    let $tableSelect = $('#erm_table_id'); 

    function fetchAvailableTables() {
        let date = $dateInput.val();
        let time = $timeInput.val();
        if (!date || !time) return;

        $.ajax({
            url: `${window.RestaurantMenuMangeData.rest_api}/available-tables`,
            type: 'GET',
            data: { reservation_date: date, reservation_time: time },
            success: function (response) {
                console.log(response);
                $tableSelect.empty().append('<option value="">Select Table</option>');
                if (response.tables && response.tables.length > 0) {
                    response.tables.forEach(table => {
                        $tableSelect.append(`<option value="${table.id}"> ${table.table_number}, (Capacity ${table.capacity})</option>`);
                    });
                } else {
                    $tableSelect.append('<option value="">No available tables</option>');
                }
            },
            error: function () {
                console.error("Error fetching available tables.");
            }
        });
    }

    $dateInput.on('change', fetchAvailableTables);
    $timeInput.on('change', fetchAvailableTables);

    $submit.on('click', function (e) {
        e.preventDefault();
        let formDataArray = $form.serializeArray();
        let formObject = {};
        formDataArray.forEach(item => {
            formObject[item.name] = item.value;
        });
        const validateFormData = validation(formObject);
        console.log({validateFormData})
        if (validateFormData !== true) {
            let errors = validateFormData;
            $form.find('.tm_error').remove();
            for (let key in errors) {
                $form.find(`[name="${key}"]`).after(`<div class="tm_error">${errors[key]}</div>`);
            }
            return;
        }
        console.log(window.RestaurantMenuMangeData, 'asdasd');

        // Make an AJAX request to post the reservation
        $.ajax({
            url: `${window.RestaurantMenuMangeData.rest_api}/postReservation`,
            type: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'easyRestaurantManager-nonce': window.RestaurantMenuMangeData.nonce,
            },
            data: JSON.stringify(formObject),
            success: function (response) {
                console.log(response);
                if (response.message === 'Table created successfully') {
                    $form.find('.tm_error').remove();
                    $form.find('.tm_success').remove();
                    $form.append('<div class="tm_success">Reservation has been made successfully</div>');
                    $form[0].reset();
                    $tableSelect.empty().append('<option value="">Select Table</option>'); // RESET TABLE DROPDOWN
                } else {
                    $form.find('.tm_error').remove();
                    $form.find('.tm_success').remove();
                    $form.append('<div class="tm_error">Something went wrong. Please try again later</div>');
                }
            },
            error: function (xhr) {
                console.error("Error:", xhr.responseJSON);
                $form.find('.tm_error').remove();
                $form.find('.tm_success').remove();
                $form.append('<div class="tm_error">Something went wrong. Please try again later</div>');
            }
        });
    });

    const validation = (formData) => {
        let errors = {};
        if (!formData.customer_name) {
            errors.customer_name = 'Customer name is required';
        }
        if (!formData.email) {
            errors.email = 'Customer email is required and should be valid email format';
        }
        if (!formData.phone) {
            errors.phone = 'Customer phone is required';
        }
        if (!formData.reservation_date) {
            errors.reservation_date = 'Reservation date is required';
        }
        if (!formData.reservation_time) {
            errors.reservation_time = 'Reservation time is required';
        }
        if (!formData.num_guests) {
            errors.num_guests = 'Number of guests is required';
        }
        if (!formData.table_id) {
            errors.table_id = 'Table selection is required';
        }
        return Object.keys(errors).length > 0 ? errors : true;
    }

    $('.erm_reservation-date-picker').on('change', checkTableAvailability())
    $('.erm_table_time_slot').on('click', function() {
        $(this).siblings().removeClass('erm_time_slot_selected');
        $(this).toggleClass('erm_time_slot_selected');
        checkTableAvailability();
    })

    function checkTableAvailability() {
        let date = $('.erm_reservation-date-picker').val();
        let time = $('.erm_time_slot_selected').data('erm_table_time_slot')
        if (!date || !time) return;
        $.ajax({
            url: `${window.RestaurantMenuMangeData.rest_api}/available-tables`,
            type: 'GET',
            data: { reservation_date: date, reservation_time: time },
            success: function (response) {
                $('.erm_reservation-table').each(function() {
                    let tableId = $(this).data('erm_reservation_table_id');
                    if (response.tables.some(table => table.id == tableId)) {
                        $(this).removeClass('reserved');
                        $(this).addClass('available');
                    } else {
                        $(this).removeClass('available');
                        $(this).addClass('reserved');
                    }
                })
            },
            error: function () {
                console.error("Error fetching available tables.");
            }
        });
    }

});
